import {
  Dropdown,
  DropdownDivider,
  DropdownItem,
  DropdownSubmenu,
  IconButton,
} from 'platform/components';
import {Icon, Show, Text} from 'platform/foundation';
import {match} from 'ts-pattern';

import {Fragment} from 'react';

import {suffixTestId, TestIdProps} from 'shared/web';

interface KebabMenuEntry {
  label: string;
  onClick: () => void;
  isDisabled?: boolean;
  isChecked?: boolean;
}

export type KebabMenuItem =
  | {type: 'item'; label: string; onClick: () => void; isDisabled?: boolean; isDanger?: boolean}
  | {type: 'divider'}
  | {type: 'submenu'; label: string; items: KebabMenuEntry[]};

export interface KebabMenuProps extends TestIdProps {
  items: KebabMenuItem[];
  'aria-label': string;
}

export function KebabMenu(props: KebabMenuProps) {
  return (
    <Dropdown
      placement="bottom-end"
      data-testid={suffixTestId('kebabMenu', props)}
      dropdownControl={
        <IconButton
          icon="navigation/more_vert"
          size="small"
          aria-label={props['aria-label']}
          data-testid={suffixTestId('kebabMenuButton', props)}
        />
      }
    >
      {props.items.map((item, index) =>
        match(item)
          .with({type: 'divider'}, () => <DropdownDivider key={`divider-${index}`} />) // eslint-disable-line react/no-array-index-key -- Pre-existing violation
          .with({type: 'submenu'}, (submenu) => (
            // eslint-disable-next-line react/no-array-index-key -- Pre-existing violation
            <DropdownSubmenu key={`submenu-${index}`} label={submenu.label} placement="left-start">
              {submenu.items.map((entry, entryIndex) => (
                <DropdownItem
                  key={`entry-${entryIndex}`} // eslint-disable-line react/no-array-index-key -- Pre-existing violation
                  label={entry.label}
                  isDisabled={entry.isDisabled}
                  onClick={entry.onClick}
                  suffix={
                    <Show when={entry.isChecked}>
                      <Icon value="navigation/check" size={4} />
                    </Show>
                  }
                />
              ))}
            </DropdownSubmenu>
          ))
          .with({type: 'item'}, (entry) => (
            // eslint-disable-next-line react/no-array-index-key -- Pre-existing violation
            <Fragment key={`item-${index}`}>
              {entry.isDanger ? (
                <DropdownItem
                  label={
                    <Text size="small" color="danger">
                      {entry.label}
                    </Text>
                  }
                  isDisabled={entry.isDisabled}
                  onClick={entry.onClick}
                />
              ) : (
                <DropdownItem
                  label={entry.label}
                  isDisabled={entry.isDisabled}
                  onClick={entry.onClick}
                />
              )}
            </Fragment>
          ))
          .exhaustive()
      )}
    </Dropdown>
  );
}
